import { toast } from "react-toastify"

export const ThrowErrorEvent = (error?: string) => {
    toast.error(error ? `Ocorreu um erro ao ${error}, verifique sua rede ou contate o suporte!` : "Ocorreu um erro, verifique sua rede ou contate o suporte")
}